<template>
  <div v-loading="loading" class="affiliate-reward-report">
    <el-row>
      <el-col>
        <div class="table-cover">
          <table class="two-d">
            <thead>
              <tr>
                <th>集計日 <span class="notice-text">※1</span></th>
                <th>振込日 <span class="notice-text">※2</span></th>
                <th>獲得報酬</th>
                <th>繰越報酬額</th>
                <th>報酬合計</th>
                <th>手数料</th>
                <th>振込金額</th>
                <th>繰越報酬額</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(monthlyReportData, index) in monthlyReportList" :key="index">
                <th>{{ monthlyReportData.objectMonth }}</th>
                <th>
                  <span v-if="monthlyReportData.paymentType === '0'">{{ monthlyReportData.transferDate }}</span>
                  <span v-else>-</span>
                </th>
                <td>{{ monthlyReportData.monthlyTotal | localeNum }}</td>
                <td>{{ monthlyReportData.amountCarriedOver | localeNum }}</td>
                <td>{{ monthlyReportData.rewardTotal | localeNum }}</td>
                <td>{{ monthlyReportData.fee | localeNum }}</td>
                <td>
                  <div>
                    <span v-if="monthlyReportData.paid === false">（準備中）</span>
                    <span>{{ monthlyReportData.transferAmount | localeNum }}</span>
                  </div>
                </td>
                <td>{{ monthlyReportData.amountCarriedForward | localeNum }}</td>
              </tr>
            </tbody>
          </table>
          <div class="notice">
            <div>
              <span>※当画面をキャプチャして明細としてご利用ください。</span>
              <div>※1 記載の集計日に前月分の報酬額（+繰越報酬額）が集計されます。</div>
              <div>※2 銀行振込の場合の振込日。</div>
            </div>
            <span style="text-align: right">
              レポート最終更新日：{{ updatedDate }}
              <br />金額の単位は円・すべて税込表示
            </span>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "AffiliateRewardReport",
  components: {},
  props: {
    monthRange: Array,
  },
  data() {
    return {
      loading: true,
      updatedDate: "",
      monthlyReportList: [],
    };
  },
  computed: {
    ...mapGetters(["rt", "apiErrorMessage"]),
  },
  watch: {
    monthRange: {
      handler(newMonthRange) {
        this.getMonthlyReportList(newMonthRange);
      },
      immediate: true,
    },
  },
  methods: {
    getMonthlyReportList(monthRange) {
      // 
      this.loading = true;

      // 
      this.$axios
        .get(`${this.rt}/l/api/affiliate/get-reward-list?month_range=${encodeURIComponent(JSON.stringify(monthRange))}`)
        .then((response) => {
          console.log(response);
          if (response.data.status === 200) {
            this.updatedDate = response.data.updatedDate;
            this.monthlyReportList = response.data.list;
          } else if (response.data.status === 400) {
            alert(response.data.message);
          } else if (response.data.status === 401) {
            alert(response.data.message);
            this.$router.push("/login");
          } else {
            alert(this.apiErrorMessage);
          }
          return;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.table-cover {
  table {
    &.two-d {
      .notice-text {
        font-size: 12px;
        color: #999;
      }
    }
  }

  .notice {
    display: flex;
    justify-content: space-between;
  }
}
</style>
